import { medicalPatient, officeAsset, retailExhibition } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/constructionEquipment/video/rtlsVideo.mp4';

export default {
  desc: 'Smart Airport (Sân bay thông minh) là những sân bay sử dụng công nghệ hiện đại và hệ thống tiên tiến để cung cấp dịch vụ tối ưu cho du khách. Mục tiêu của chúng là tối đa hóa hiệu quả và đổi mới trải nghiệm du lịch thông qua các công nghệ thông minh và đổi mới kỹ thuật số đa dạng.',
  keywords: 'Smart Airport, RTLS, Digital Twin, Theo dõi vị trí, Theodoivitri\n',
  ogSite: 'Giải pháp Smart Airport',
  title: 'Giải pháp Smart Airport',
  ogUrl: 'https://orbro.io/vi/blog/smart-airport-solution',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDnB84Bj2f8mz7hiRJi4WKgwiYq0yzs4GDe7VfFWOdEiQPlqEtyMMpSU-r7CcKy3BQ9FE63-XkxXVh-VAf440HOH1GA2iUOdHrknQN9GTI5y3ciXRGd5tlYsj4DhnmSkYTQpZas8pKO2QTEY2Yr1aKg7FEDLt0kRSvFKTZggTvuJepKze-kTLdpe_706Vc5UevQyGXNClLc9oJpNJDRuQC6tUHKnn_FiW52O6uSCoGFs28ONxKiUPRFE5Ju29eGYw_NfFWK5qCYQkem15ivnuMMmQSfx2L1JMQGPPP__JQ8WwQTWf0fqJZrIOChm-Ytl3cTDljPsL84S4SK3ww7wvpdBVVnfeI_Hg9DIMDCgf2m4_GsjXhNuJb8f9tyjQix7woDC35BeyLXjFP9o2ERnbG7fyvuPfPIRBgK5nDmmQ-wLv8t6GiBIp0c9271KpuXrz_4fq6Pq0V18HWuznis8j9ij1ifWmZi0BufNpYrlKZ2RdY4lq_6Gr9vc4ZPYRfJ-NFKGBI03EKiA9vlIrzcQTS3aEzIVovappIABtvO8PxqCkqhF0amIzISUH2Y5efT1YtPEGCevRdIC2I9_V7SvrQTvm0Qnp6vF-xmdybPAnJr0BD0vT05fpxoeHcN_WbUEtUQcbFsq6v1TanDDnB-XLp6Hj1LBhEApO0KLMdKr6hqANaGkrweuLO-ppA1rq_sNPCwSoX3tInq-mGVn9-HfzIH4u1P52EJjPxNZh60gOpVuZqkyH0P7dKgHso5PfMXAHJJwBIhCrzzILpZN8rrqZZvgP7AKPfAS06cevU6M0PaN0pZiHywpvCcQVdty1VzWLryj5hS4cQmTfrC3GcAHFJBDMgSUdZAhbiB7MSwtMhcD4ye-9kOD85_PonAQG9QMZMyrDPuna6Rnfr3NNhtq5VLL4M2wMxmiUDvxHg1WMRsQIoR-KUoTQ7imcUxIkCvzVkMe0UgWhSU3oamalc9rvOKud9cDgvAzuC1Pi4TUFJEZoHIvWiSKf6fqf7_yqlGHA5CggXGmBUVlSUJKMz4AF25WfOC3t3lBYczZ7sdmtLr4oU5MSzzsuoU1ZRAsXu21sJkggnYNxqgP12eulaDnKgNC2v2tUoVFG3FM0dx4L9exFCMlSC4o25cBb7aCwOiAArJL-pUeJfoo0RWP79r8X-Fai40OnK_c9Mu3JLlhPbxgOsjIIIqErT8CygE-qJyrNdf7TY6j9Onn6HFhBE3IeCPrkrAbSVNLPT43ZP_PQeII9yOMYE1U9feIAsW6V2sC75YSru67__inv-Qj90ltj2FbqExBTfA2Yr-kLz4oeF05ygNcG4IyVyMb40jXPlED8eAhW-C3QHc4YQUCMvuu6Di-Lbgtce_nkq_428rQwjdjJDzejxpTy6tyIKxtYbtWMLS2siVXz5PQ07dAbC6fOPlh5x1vyFEsMroUS20vNOqxpVKPYNog4lmhOQ5_KeNNrSPhRy2_zHR0c5l3sOApfG7vMjyOHlwSXmthwYqL1_Hgz_WbJ_B1jLdHt8fpAOw6KWq_yUsDx0yS9mIzNjDitluARF04p2PJ=w2038-h1285',
  ogType: 'website',
  date: '2024-01-16',
  tag1: '#RTLS',
  tag2: '#SmartAirport',
  tag3: '#DigitalTwin',
  tag4: '#Theodoivitri',
  text: [
    {
      head: 'Giải pháp Smart Airport',
      subHead: '',
      desc: 'Smart Airport (Sân bay thông minh) là những sân bay sử dụng công nghệ hiện đại và hệ thống tiên tiến để cung cấp dịch vụ tối ưu cho du khách. Mục tiêu của chúng là tối đa hóa hiệu quả và đổi mới trải nghiệm du lịch thông qua các công nghệ thông minh và đổi mới kỹ thuật số đa dạng.\nĐiều này giúp cách mạng hóa trải nghiệm du lịch và tối đa hóa hiệu quả bằng cách sử dụng nhiều công nghệ thông minh khác nhau như điều hòa môi trường trong nhà, hệ thống an ninh dựa trên AI và công nghệ RTLS. Smart Airport tập trung vào việc nâng cao sự hài lòng của khách hàng bằng cách cung cấp các dịch vụ được tối ưu hóa ở mọi giai đoạn của hành trình.',
      dot: '',
    },
    {
      head: 'Công nghệ Smart Airport',
      subHead: '',
      desc: 'Smart Airport sử dụng nhiều công nghệ tiên tiến để cung cấp dịch vụ đổi mới và tiện lợi cho du khách. Các công nghệ có thể được áp dụng trong Smart Airport bao gồm:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hệ thống Điều hòa Môi trường trong nhà',
      desc: ' Smart Airport đang triển khai hệ thống điều hòa môi trường trong nhà để cung cấp môi trường tối ưu cho du khách. Thông qua đó, bằng cách giám sát và điều chỉnh nhiệt độ, độ ẩm, chất lượng không khí bên trong sân bay theo thời gian thực, du khách có thể thoải mái chờ đợi. Ngoài ra, hệ thống chiếu sáng thông minh mô phỏng ánh sáng tự nhiên và nâng cao hiệu quả năng lượng, mang lại sự tiện lợi trong cuộc sống cho du khách.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hệ thống An ninh dựa trên AI',
      desc: 'An toàn là một trong những giá trị cốt lõi của du lịch. Smart Airport đang xây dựng hệ thống an ninh tiên tiến thông qua camera AI. Việc kết hợp công nghệ nhận diện khuôn mặt, phân tích hành vi và phát hiện hành vi bất hợp pháp giúp nâng cao mức độ bảo mật, mang lại sự an tâm cho du khách. Ngoài ra, hệ thống có thể phát hiện các dấu hiệu bất thường theo thời gian thực để có biện pháp xử lý kịp thời.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Công nghệ RTLS (Real-Time Location System)',
      desc: 'Bằng cách sử dụng công nghệ theo dõi vị trí theo thời gian thực được gọi là RTLS, vị trí của du khách được theo dõi theo thời gian thực. Điều này cho phép sân bay kết nối hiệu quả với cổng, cửa hàng và hệ thống vận chuyển hành lý, tối ưu hóa sự di chuyển của du khách. Ngoài ra, nó còn cung cấp dữ liệu có ý nghĩa cho việc phân tích luồng di chuyển và quản lý an toàn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Phân tích Dữ liệu và Trí tuệ nhân tạo',
      desc: 'Phân tích dữ liệu sử dụng Big Data và Trí tuệ nhân tạo (AI) đóng vai trò lớn trong việc tối ưu hóa hoạt động của Smart Airport. Các mô hình di chuyển của du khách, xu hướng sử dụng dịch vụ, v.v., được phân tích để sử dụng trong việc vận hành hiệu quả và đưa ra các điểm cải tiến. Điều này giúp các nhà quản lý sân bay bố trí tài nguyên hiệu quả và cung cấp dịch vụ tốt hơn cho du khách.',
      dot: '',
    },
    {
      head: 'Ưu điểm của Smart Airport',
      subHead: 'Trải nghiệm du lịch tiện lợi',
      desc: 'Smart Airport cung cấp mức độ tiện lợi cao cho du khách thông qua các quy trình làm thủ tục tự động và cung cấp thông tin theo thời gian thực. Tự động check-in, xác minh bảo mật bằng nhận diện khuôn mặt, v.v., giúp du khách di chuyển và sử dụng dịch vụ một cách thuận lợi.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường An toàn và Bảo mật',
      desc: 'Hệ thống an ninh thông minh sử dụng camera AI và công nghệ nhận diện khuôn mặt nâng cao an toàn cho du khách và phát hiện sớm các sự cố an toàn hoặc mối đe dọa bên trong sân bay. Điều này mang lại một môi trường du lịch an toàn và đáng tin cậy hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Vận hành và Quản lý Tài nguyên hiệu quả',
      desc: 'Phân tích dữ liệu và sử dụng Big Data giúp Smart Airport tối ưu hóa hoạt động và quản lý tài nguyên hiệu quả. Thông qua đó, công nghệ AI hiểu được mô hình di chuyển của du khách và tối ưu hóa các tài nguyên cần thiết để nâng cao hiệu quả vận hành.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tối ưu hóa Môi trường trong nhà',
      desc: 'Hệ thống điều hòa môi trường trong nhà giúp du khách có thể chờ đợi trong một môi trường thoải mái. Bằng cách giám sát và điều chỉnh nhiệt độ, độ ẩm, chất lượng không khí theo thời gian thực, nó nâng cao sự tiện lợi cho du khách và cung cấp một môi trường chờ đợi chất lượng cao.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Quy trình làm thủ tục và ra vào nhanh chóng',
      desc: 'Quy trình làm thủ tục tự động giúp du khách giảm bớt các thủ tục rườm rà, đồng thời cung cấp quy trình check-in và ra vào nhanh chóng. Điều này giúp du khách tiết kiệm thời gian và di chuyển thuận tiện.',
      dot: '',
    },
    {
      head: 'Các trường hợp ứng dụng Smart Airport',
      subHead: 'Hamad International Airport (DOH), Qatar',
      desc: 'Sân bay Quốc tế Hamad đang tích cực áp dụng công nghệ thông minh để cung cấp các dịch vụ cao cấp như một phần của Smart City. Các dịch vụ đã được triển khai bao gồm dịch vụ hướng dẫn bằng robot tự động, hệ thống an ninh thông minh và dịch vụ tiện ích cho hành khách thông qua ứng dụng di động.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Changi Airport (SIN), Singapore',
      desc: 'Sân bay Changi được coi là một trong những sân bay tốt nhất thế giới nhờ tích cực áp dụng các công nghệ đổi mới. Các hệ thống đã được triển khai như hệ thống check-in tự động, xử lý hành lý thông minh, và các trạm thông minh trong sân bay mang đến sự tiện lợi cao cấp cho du khách.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Dubai International Airport (DXB), Các Tiểu vương quốc Ả Rập Thống nhất',
      desc: 'Sân bay Quốc tế Dubai đang phát triển thành một trung tâm du lịch quốc tế với công nghệ thông minh và các dịch vụ đổi mới. Các hệ thống đã được triển khai bao gồm hệ thống an ninh thông minh dựa trên AI, phương tiện tự lái, và cải thiện trải nghiệm hành khách thông qua ứng dụng di động.',
      dot: '',
    },
    {
      head: '',
      subHead: 'San Francisco International Airport (SFO), Hoa Kỳ',
      desc: 'Sân bay Quốc tế San Francisco đang được chú ý nhờ hoạt động hiệu quả và các dịch vụ thông minh. Các đặc điểm nổi bật bao gồm giám sát môi trường trong nhà sử dụng IoT, hệ thống xử lý hành lý thông minh, và tăng cường tiện ích cho hành khách thông qua ứng dụng di động.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: officeAsset.thumb,
        data: 'officeAsset',
        link: '/vi/enterprise/office/asset',
      },
    ],
  },
};
